/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuredSummaryDto } from './InsuredSummaryDto';
import {
    InsuredSummaryDtoFromJSON,
    InsuredSummaryDtoFromJSONTyped,
    InsuredSummaryDtoToJSON,
    InsuredSummaryDtoToJSONTyped,
} from './InsuredSummaryDto';

/**
 * 
 * @export
 * @interface GetInsuredListResponseDto
 */
export interface GetInsuredListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetInsuredListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<InsuredSummaryDto>}
     * @memberof GetInsuredListResponseDto
     */
    items: Array<InsuredSummaryDto>;
}

/**
 * Check if a given object implements the GetInsuredListResponseDto interface.
 */
export function instanceOfGetInsuredListResponseDto(value: object): value is GetInsuredListResponseDto {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetInsuredListResponseDtoFromJSON(json: any): GetInsuredListResponseDto {
    return GetInsuredListResponseDtoFromJSONTyped(json, false);
}

export function GetInsuredListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInsuredListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(InsuredSummaryDtoFromJSON)),
    };
}

export function GetInsuredListResponseDtoToJSON(json: any): GetInsuredListResponseDto {
    return GetInsuredListResponseDtoToJSONTyped(json, false);
}

export function GetInsuredListResponseDtoToJSONTyped(value?: GetInsuredListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(InsuredSummaryDtoToJSON)),
    };
}

